import { Component, Input, OnInit, ViewChild, OnChanges, ElementRef, SimpleChanges, Inject, PLATFORM_ID } from '@angular/core';
import { RecommendedArticlesService } from '../recommended-articles/recommended-articles.service';
import { GoogleAnalyticsService } from '../../../google-analytics.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-recommended-articles',
  templateUrl: './recommended-articles.component.html',
  styleUrls: ['./recommended-articles.component.scss']
})
export class RecommendedArticlesComponent implements OnInit, OnChanges {
  @Input() currentArticleId!: number;
  @Input() currentArticleTitle?: string; 
  @ViewChild('recommendedSection') recommendedSection!: ElementRef;
  private sectionViewed = false;

  articles: any[] = [];

  constructor(private recommendedService: RecommendedArticlesService,  private ga: GoogleAnalyticsService, @Inject(PLATFORM_ID) private platformId: Object ) {}

  ngOnInit(): void {
    if (!this.currentArticleId) return;

    this.recommendedService.getRecommendedArticles(this.currentArticleId)
      .subscribe((posts: any[]) => {
        this.articles = posts;
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['currentArticleId'] && !changes['currentArticleId'].firstChange) {
      this.loadRecommended();
    }
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId) && this.recommendedSection) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.sectionViewed) {
            this.ga.trackEvent('recommended_section_viewed', {
              category: 'engagement',
              label: 'recommended_articles_section',
              articles_count: this.articles.length,
              source_article_id: this.currentArticleId
            });
            this.sectionViewed = true;
            observer.unobserve(entry.target);
          }
        });
      });
      
      observer.observe(this.recommendedSection.nativeElement);
    }
  }

  loadRecommended(): void {
    this.recommendedService.getRecommendedArticles(this.currentArticleId)
      .subscribe((posts) => this.articles = posts);
  }

  getImageUrl(article: any): string {
    return article.attributes.image?.data?.attributes?.url || 'default.jpg';
  }

  getAuthor(article: any): string {
    return article.attributes.publisher; //article.attributes.author?.data?.attributes?.name || 'Inconnu';
  }

  getCategory(article: any) {
    if(!article.attributes.category) {
      return "";
    }
    return article.attributes.category.data?.attributes;
  }

  // 🔥 NOUVELLE méthode de tracking
  trackRecommendedArticleClick(article: any, index: number): void {
    this.ga.trackEvent('recommended_article_click', {
      category: 'engagement',
      label: article.attributes?.title,
      article_id: article.id,
      article_slug: article.attributes?.slug,
      source_article_title: this.currentArticleTitle,
      source_article_id: this.currentArticleId,
      recommendation_position: index + 1, // Position dans la liste (1, 2, 3...)
      recommendation_section: 'recommended_articles'
    });
  }
}
